$(function() {
  if (_.get($.siteConfiguration, "show_protect_manufacture_warranty_text")) {
    renderMarkdown($('#show_protect_manufacture_warranty_text'), $.polyglot.t('claims_protect_manufacture_warranty_text', $.interpolations));
  }

  if (_.get($.siteConfiguration, "show_protect_plus_manufacture_warranty_text")) {
    renderMarkdown($('#show_protect_plus_manufacture_warranty_text'), $.polyglot.t('claims_protect_plus_manufacture_warranty_text', $.interpolations));
  }

  if (_.get($.siteConfiguration, "show_protect_manufacture_not_covered_text")) {
    renderMarkdown($('#show_protect_not_covered_text'), $.polyglot.t('claims_protect_manufacture_not_covered_text', $.interpolations));
  }

  if (_.get($.siteConfiguration, "show_protect_plus_manufacture_not_covered_text")) {
    renderMarkdown($('#show_protect_plus_not_covered_text'), $.polyglot.t('claims_protect_plus_manufacture_not_covered_text', $.interpolations));
  }

  if (_.get($.siteConfiguration, "claims")) {
    renderMarkdown($('#claims-thanks-explanation'), $.polyglot.t('claims_thanks_explanation', $.interpolations));
  }

  if (_.get($.siteConfiguration, "enable_warranty")) {
    renderMarkdown($('#claims-warranty-explanation'), $.polyglot.t('claims_warranty_explanation', $.interpolations));
  }

  if (_.get($.siteConfiguration, "enable_warranty")) {
    renderMarkdown($('#claims-custom1-warranty-explanation'), $.polyglot.t('claims_custom1_warranty_explanation', $.interpolations));
  }

  if (_.get($.siteConfiguration, "enable_esp_sales")) {
    renderMarkdown($('#claims-entitlement-explanation'), $.polyglot.t('claims_entitlement_explanation', $.interpolations));
  }

  if (_.get($.siteConfiguration, "claims")) {
    renderMarkdown($('#claims-generic-explanation'), $.polyglot.t('claims_generic_explanation', $.interpolations));
  }

  if (_.get($.siteConfiguration, "enable_warranty")) {
    renderMarkdown($('#service-confirmation-print-disclaimer'), $.polyglot.t('service_confirmation_print_disclaimer', $.interpolations));
  }
})

$(document).ready(function() {

  if ( _.get($.siteConfiguration, ["enable_esp", "enable_care_page"] ) ){
    renderMarkdown($('#care-page-headers'), $.polyglot.t('care_page_headers', $.interpolations));
    renderMarkdown($('#care-invite-page-headers'), $.polyglot.t('care_invite_page_headers', $.interpolations));
    renderMarkdown($('.care-explanation'), $.polyglot.t('care_explanation', $.interpolations));
    renderMarkdown($('#care-benefits-explanation'), $.polyglot.t('care_benefits_explanation', $.interpolations));
    renderMarkdown($('#care-disclaimer'), $.polyglot.t('care_disclaimer', $.interpolations));
    renderMarkdown($('#care-terms'), $.polyglot.t('care_terms', $.interpolations));
    renderMarkdown($('#care-faq'), $.polyglot.t('care_faq', $.interpolations));
    renderMarkdown($('#care-faq-condensed'), $.polyglot.t('care_faq_condensed', $.interpolations));
    renderMarkdown($('#care-benefit-disclaimer-text'), $.polyglot.t('care_benefit_disclaimer_text', $.interpolations));
  }
  if ( _.get($.siteConfiguration, "enable_esp_sales" ) ){
    renderMarkdown($('#protect-page-product-image-text'), $.polyglot.t('protect_page_product_image_text', $.interpolations));
    renderMarkdown($('#protect-page-product-image-text-2'), $.polyglot.t('protect_page_product_image_text_2', $.interpolations));
    renderMarkdown($('#protect-page-product-image-text-3'), $.polyglot.t('protect_page_product_image_text_3', $.interpolations));
    renderMarkdown($('#protect-page-product-intro'), $.polyglot.t('protect_page_product_intro', $.interpolations));
    renderMarkdown($('#protect-page-benefit-heading-text'), $.polyglot.t('protect_page_benefit_heading_text', $.interpolations));
    renderMarkdown($('#protect-page-activate-text'), $.polyglot.t('protect_page_activate_text', $.interpolations));
    renderMarkdown($('#protect-page-banner-text'), $.polyglot.t('protect_page_banner_text', $.interpolations));
  }
  if ( _.get($.siteConfiguration, "enable_esp_sales" ) ){
    renderMarkdown($('#care_plan_1_message'), $.polyglot.t('care_plan_1_message', $.interpolations));
    renderMarkdown($('#care_plan_2_message'), $.polyglot.t('care_plan_2_message', $.interpolations));
    renderMarkdown($('#renewal-decline-text'), $.polyglot.t('care_decline_message', $.interpolations));
    renderMarkdown($('#care-benefits-heading-text'), $.polyglot.t('esp_benefits_title_heading', $.interpolations));
  }
});

$(function() {
  $('.mobile-sidebar-toggler').on('click', function(){
    $('body.portal').toggleClass('sidebar-open');
  });
});

$(function() {
  $('#portal-profile-edit-btn').on('click', function(){
    $("#portal-profile-edit").removeClass('d-none');
    $("#portal-profile-view").addClass('d-none');
  });
  $('#portal-profile-edit-cancel-btn').on('click', function(){
    $("#portal-profile-edit").addClass('d-none');
    $("#portal-profile-view").removeClass('d-none');
  });
});

$(function() {
	if($.cookie("referrer") == "app"){
		$('.aura-sidebar').addClass("app-d-none");
    $('.aura-header').addClass("app-d-none");
  }
});
$(document).ready(function() {
  if ( _.get($.siteConfiguration,"enable_portal" ) ){
    renderMarkdown($('#portal-page-headers'), $.polyglot.t('portal_page_headers', $.interpolations));
  }

  renderMarkdown($('#footer-text'), $.polyglot.t('footer_text', $.interpolations));

  if ( _.get($.siteConfiguration,"enable_portal_disclaimer" ) ){
    renderMarkdown($('#portal-disclaimer'), $.polyglot.t('portal_disclaimer', $.interpolations));
  }
});